export class EffectManager {

    constructor() {
        this.effects = [];

        // low quality settings (off)
        this.enabled = true;
    }

    add(effect) {
        effect.onStart();
        this.effects.push(effect);
        return effect;
    }

    remove(effect) {
        const i = this.effects.indexOf(effect);
        if (i === -1) return;
        effect.onEnd();
        this.effects.splice(i, 1);
    }

    // remove all effects from an object
    removeForMesh(mesh, category = null) {
        const toRemove = this.effects.filter(e =>
            e.mesh === mesh && (category === null || e.category === category)
        );
        toRemove.forEach(e => this.remove(e));
    }

    //remove all effects from a category
    removeByCategory(category) {
        const toRemove = this.effects.filter(e => e.category === category);
        toRemove.forEach(e => this.remove(e));
    }


    //removes all effects

    clear() {

        // Iterate backwards so splice doesn't skip entries
        for (let i = this.effects.length - 1; i >= 0; i--) {
            this.effects[i].onEnd();
        }
        this.effects = [];

    }

    //update effects
    
    update(dt) {
        if (!this.enabled) return;

        for (let i = this.effects.length - 1; i >= 0; i--) {
            const effect = this.effects[i];
            effect.update(dt);

            if (effect.finished) {
                effect.onEnd();
                this.effects.splice(i, 1);
            }
        }
    }
}